import { useNavigate } from "react-router-dom"
import { useAdminLoaders, useRequestLoaders, useSystemActions } from "../../../../modules/system"
import { define } from "../../../../utils/typeUtils"
import { useRoutesHooks } from "../../hooks/routesHooks"
import { RoutePath } from "../../types"
import { firstItem } from "../../../../utils/listUtils"

export const useLoad = () => {
    const { loadUser } = useRoutesHooks()
    const navigate = useNavigate()

    const adminLoaders = useAdminLoaders()
    const requestLoaders = useRequestLoaders()

    const systemActions = useSystemActions()

    return async () => {
        const { fetchCompanyById } = systemActions()

        const user = await loadUser()

        if (user)  {
            const { loadAdmin } = adminLoaders()
            const admin = await loadAdmin(user.id)
            if (admin && admin.id === user.id) {
                navigate(RoutePath.ADMIN)
            } else {
                const { loadUserRequests } = requestLoaders()
                const requests = await loadUserRequests(user.id, true)
                const request = firstItem(requests)
                if (request) {
                    const company = await fetchCompanyById(request.companyId)
                    navigate(`/${define(company).code}`)
                } else {
                    navigate(RoutePath.ERROR)
                }
            }
        }
    }
}
